// extracted by mini-css-extract-plugin
export default {"updateButton":"styles_updateButton__Ltofl"};